import { useEffect, useState } from 'react';

export const useVisibilityListerner = () => {
  const [visibility, setVisibility] = useState(false);

  const onVisibilitychange = () => {
    setVisibility(document.visibilityState === 'visible');
  };

  useEffect(() => {
    onVisibilitychange();

    document.addEventListener('visibilitychange', onVisibilitychange);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilitychange);
    };
  }, []);

  return visibility;
};
